export * from './getSystemDetails';